"use strict";
/**
 * Copyright 2018 Google LLC
 *
 * Distributed under MIT license.
 * See file LICENSE for detail or copy at https://opensource.org/licenses/MIT
 */

var _regeneratorRuntime = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var gaxios_1 = require("gaxios");

var jsonBigint = require('json-bigint');

exports.HOST_ADDRESS = 'http://metadata.google.internal.';
exports.BASE_PATH = '/computeMetadata/v1';
exports.BASE_URL = exports.HOST_ADDRESS + exports.BASE_PATH;
exports.HEADER_NAME = 'Metadata-Flavor';
exports.HEADER_VALUE = 'Google';
exports.HEADERS = Object.freeze(_defineProperty({}, exports.HEADER_NAME, exports.HEADER_VALUE)); // Accepts an options object passed from the user to the API. In previous
// versions of the API, it referred to a `Request` or an `Axios` request
// options object.  Now it refers to an object with very limited property
// names. This is here to help ensure users don't pass invalid options when
// they  upgrade from 0.4 to 0.5 to 0.8.

function validate(options) {
  Object.keys(options).forEach(function (key) {
    switch (key) {
      case 'params':
      case 'property':
      case 'headers':
        break;

      case 'qs':
        throw new Error("'qs' is not a valid configuration option. Please use 'params' instead.");

      default:
        throw new Error("'".concat(key, "' is not a valid configuration option."));
    }
  });
}

function metadataAccessor(_x, _x2) {
  return _metadataAccessor.apply(this, arguments);
} // tslint:disable-next-line no-any


function _metadataAccessor() {
  _metadataAccessor = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(type, options) {
    var noResponseRetries,
        property,
        res,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            noResponseRetries = _args.length > 2 && _args[2] !== undefined ? _args[2] : 3;
            options = options || {};

            if (typeof options === 'string') {
              options = {
                property: options
              };
            }

            property = '';

            if (typeof options === 'object' && options.property) {
              property = '/' + options.property;
            }

            validate(options);
            _context.prev = 6;
            _context.next = 9;
            return gaxios_1.request({
              url: "".concat(exports.BASE_URL, "/").concat(type).concat(property),
              headers: Object.assign({}, exports.HEADERS, options.headers),
              retryConfig: {
                noResponseRetries: noResponseRetries
              },
              params: options.params,
              responseType: 'text'
            });

          case 9:
            res = _context.sent;

            if (!(res.headers[exports.HEADER_NAME.toLowerCase()] !== exports.HEADER_VALUE)) {
              _context.next = 14;
              break;
            }

            throw new Error("Invalid response from metadata service: incorrect ".concat(exports.HEADER_NAME, " header."));

          case 14:
            if (res.data) {
              _context.next = 16;
              break;
            }

            throw new Error('Invalid response from the metadata service');

          case 16:
            if (!(typeof res.data === 'string')) {
              _context.next = 23;
              break;
            }

            _context.prev = 17;
            return _context.abrupt("return", jsonBigint.parse(res.data));

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](17);

          case 23:
            return _context.abrupt("return", res.data);

          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](6);

            if (_context.t1.response && _context.t1.response.status !== 200) {
              _context.t1.message = "Unsuccessful response status code. ".concat(_context.t1.message);
            }

            throw _context.t1;

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 26], [17, 21]]);
  }));
  return _metadataAccessor.apply(this, arguments);
}

function instance(options) {
  return metadataAccessor('instance', options);
}

exports.instance = instance; // tslint:disable-next-line no-any

function project(options) {
  return metadataAccessor('project', options);
}

exports.project = project;
/**
 * Determine if the metadata server is currently available.
 */

function isAvailable() {
  return _isAvailable.apply(this, arguments);
}

function _isAvailable() {
  _isAvailable = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return metadataAccessor('instance', undefined, 0);

          case 3:
            return _context2.abrupt("return", true);

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);

            if (!(_context2.t0.code && (_context2.t0.code === 'ENOTFOUND' || _context2.t0.code === 'ENOENT'))) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", false);

          case 10:
            throw _context2.t0;

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _isAvailable.apply(this, arguments);
}

exports.isAvailable = isAvailable;